module.exports = __webpack_public_path__ + "img/leaves-front-1x.73043315.png";